import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const resolveOrderWithoutReorder = async (resolveOrderId: string) => {
  const response = await queryExecute({
    variables: {
      resolveOrderId,
    },
    query: graphql(`
      query ResolveOrderWithoutReorder($resolveOrderId: String!) {
        resolveOrderWithoutReorder(resolveOrderId: $resolveOrderId)
      }
    `),
  });

  return response.data?.resolveOrderWithoutReorder;
};
